<section class="short-talk-chat d-flex flex-column h-100">
  @if (isIntroVisible()) {
    <div class="short-talk-intro">
      <div class="short-talk-intro-icon" aria-hidden="true">
        <svg class="sa-icon sa-bold sa-nofill short-talk-intro-icon-main">
          <use href="/assets/icons/sprite.svg#message-circle"></use>
        </svg>
        <svg class="sa-icon sa-bold sa-nofill short-talk-intro-icon-target">
          <use href="/assets/icons/sprite.svg#target"></use>
        </svg>
      </div>

      <div class="short-talk-intro-content">
        <h4 class="short-talk-intro-title mb-0">
          {{ t()["train.shortTalkIntroTitle"] }}
        </h4>
        <p class="short-talk-intro-description mb-0">
          {{ t()["train.shortTalkIntroDescription"] }}
        </p>

        <div class="short-talk-intro-context">
          @if (scenarioText) {
            <div class="short-talk-intro-context-item" role="group">
              <div class="short-talk-intro-context-label">
                {{ t()["train.shortTalkScenario"] }}
              </div>
              <div class="short-talk-intro-context-text">
                {{ scenarioText }}
              </div>
            </div>
          }

          <div class="short-talk-intro-context-item" role="group">
            <div class="short-talk-intro-context-label">
              {{ t()["train.shortTalkGoal"] }}
            </div>
            <div class="short-talk-intro-context-text">
              {{ introGoalText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    @if (canSpeakQuestion()) {
      <button
        type="button"
        class="train-question-audio-action btn btn-icon btn-outline-primary rounded-circle waves-effect"
        [class.train-audio-action-playing]="isQuestionAudioPlaying()"
        [attr.aria-label]="t()['train.listenQuestion']"
        [title]="t()['train.listenQuestion']"
        (click)="speakQuestion.emit()"
      >
        <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
          <use href="/assets/icons/sprite.svg#volume-2"></use>
        </svg>
      </button>
    }

    <div class="short-talk-chat-header">
      <h4 class="short-talk-chat-goal mb-0">
        {{ introGoalText }}
      </h4>
    </div>

    <div
      #messagesContainer
      class="short-talk-chat-messages"
      role="log"
      aria-live="polite"
    >
      @for (message of messages(); track message.id) {
        <div
          class="short-talk-chat-row"
          [class.short-talk-chat-row-learner]="message.role === 'learner'"
        >
          <div
            class="short-talk-chat-bubble"
            [class.short-talk-chat-bubble-bot]="message.role === 'bot'"
            [class.short-talk-chat-bubble-learner]="message.role === 'learner'"
          >
            {{ message.text }}
          </div>

          @if (message.role === "bot") {
            <button
              type="button"
              class="short-talk-chat-bot-listen btn btn-icon btn-outline-primary rounded-circle waves-effect"
              [class.train-audio-action-playing]="isBotMessageBusy(message.id)"
              [disabled]="!isBotMessagePlayable(message)"
              [attr.aria-label]="t()['train.shortTalkListenBotMessage']"
              [title]="t()['train.shortTalkListenBotMessage']"
              (click)="speakBotMessage(message)"
            >
              <svg class="sa-icon sa-bold sa-nofill" aria-hidden="true">
                <use href="/assets/icons/sprite.svg#volume-2"></use>
              </svg>
            </button>
          }
        </div>
      }

      @if (isSending()) {
        <div class="short-talk-chat-status" aria-live="polite">
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        </div>
      }
    </div>

    <div class="short-talk-chat-meta">
      {{ learnerTurnCount() }} / {{ maxTurns() }}
      {{ t()["train.shortTalkTurns"] }}
    </div>

    <div #messageInput class="short-talk-chat-input input-group bg-body">
      <input
        #draftInput
        [attr.maxlength]="maxMessageLength"
        type="text"
        class="form-control border-0"
        data-testid="short-talk-message-input"
        [attr.lang]="inputLang() || null"
        [attr.aria-label]="t()['train.shortTalkMessageInput']"
        [placeholder]="t()['train.shortTalkMessagePlaceholder']"
        [spellcheck]="inputSpellcheckEnabled()"
        [readOnly]="isTurnLimitReached() || isSending()"
        [value]="draftMessage()"
        (input)="onDraftInput($event)"
        (keydown.enter)="sendDraftMessage()"
      />

      <button
        type="button"
        class="short-talk-chat-mic btn btn-icon btn-outline-primary rounded-circle waves-effect align-self-center"
        [class.short-talk-chat-mic-listening]="isListening()"
        [disabled]="
          !canUseSpeechRecognition() || isTurnLimitReached() || isSending()
        "
        [attr.aria-label]="speechButtonTitle"
        [title]="speechButtonTitle"
        (click)="toggleSpeechRecognition()"
      >
        <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
          <use href="/assets/icons/sprite.svg#mic"></use>
        </svg>
      </button>

      <button
        type="button"
        class="short-talk-chat-send btn btn-icon btn-primary rounded-circle waves-effect align-self-center"
        data-testid="short-talk-send"
        [disabled]="
          !draftMessage().trim() || isTurnLimitReached() || isSending()
        "
        [attr.aria-label]="t()['train.shortTalkSend']"
        [title]="t()['train.shortTalkSend']"
        (click)="sendDraftMessage()"
      >
        <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
          <use href="/assets/icons/sprite.svg#send"></use>
        </svg>
      </button>
    </div>
  }
</section>
